<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>感控十二项指标</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="position: relative">
      <label style="position: relative; top: 20px; color: #e6a23c">
        <!-- <label style="margin-left: 10px; color: #909399">{{ title }}</label> -->
        <el-select clearable filterable v-model="searchArea" v-show="hShow" @change="areaChange" placeholder="请选择区域">
          <el-option v-for="item in areaData" :key="item.id" :label="item.label" :value="item.id">
          </el-option>
        </el-select>
        <el-select clearable filterable v-show="hShow" v-model="searchHospitalNumber" @change="hospitalChange"
          placeholder="请选择医院">
          <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
            :value="item.HospitalNumber">
          </el-option>
        </el-select>
        <el-date-picker v-model="tjny" type="monthrange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportData">导出</el-button>
        <el-button v-if="tbButton" v-show="bShow" type="primary" icon="el-icon-edit" @click="fillOut">填写结果数据</el-button>
        <el-button v-if="tbButton" v-show="!bShow" type="primary" icon="el-icon-check" @click="submit">提交</el-button>
      </label>
    </div>
    <div style="position: relative; top: 20px">
      <el-table v-show="istjny" v-loading="loading" element-loading-text="加载中" height="750"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData"
        style="width: 100%" class="indicators">
        <el-table-column align="center" label="感控十二项指标">
          <el-table-column prop="zb" label="指标" width="100"> </el-table-column>
          <el-table-column prop="nr" label="内容" width="250"> </el-table-column>
          <el-table-column prop="fz" label="分子" width="250"> </el-table-column>
          <el-table-column label="分子数值" width="180">
            <template slot-scope="scope">
              <el-input :readonly="!filled" type="number" @change="jsjg(scope.row, scope.$index)"
                v-model="scope.row.fzsz"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="fm" label="分母" width="250"> </el-table-column>
          <el-table-column label="分母数值" width="180">
            <template slot-scope="scope">
              <el-input :readonly="!filled" type="number" @change="jsjg(scope.row, scope.$index)"
                v-model="scope.row.fmsz"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="结果数据" width="180">
            <template slot-scope="scope">
              <el-input readonly v-model="scope.row.sj"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="bz" label="备注"> </el-table-column>
        </el-table-column>
      </el-table>
      <el-table v-show="!istjny" v-loading="loading" element-loading-text="加载中" height="750"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData2"
        style="width: 100%" class="table">
        <el-table-column fixed="left" prop="dataType" label="备注" width="110"> </el-table-column>
        <el-table-column fixed="left" prop="name" label="市" width="80"> </el-table-column>
        <el-table-column fixed="left" prop="HospitalLevel" label="级别" width="80"> </el-table-column>
        <el-table-column fixed="left" prop="hospitalProperty" label="类型" width="80"> </el-table-column>
        <el-table-column fixed="left" prop="HospitalName" label="医院名称" width="220"> </el-table-column>
        <el-table-column fixed="left" prop="tjny" label="统计月份"> </el-table-column>
        <el-table-column label="指标一">
          <el-table-column prop="fz1" label="实际开放床位数" />
          <el-table-column prop="fm1" label="同期感控专职人员数" />
          <el-table-column prop="sj1" label="感控专职人员床位比" />
        </el-table-column>
        <el-table-column label="指标二">
          <el-table-column prop="fz2" label="医疗机构工作人员实际执行手卫生时机数" />
          <el-table-column prop="fm2" label="同期应执行手卫生时机数" />
          <el-table-column prop="sj2" label="医疗机构工作人员手卫生依从率(%)" />
          <el-table-column prop="fz2_1" label="医疗机构医生人员实际执行手卫生时机数" />
          <el-table-column prop="fm2_1" label="同期医生人员应执行手卫生时机数" />
          <el-table-column prop="sj2_1" label="医疗机构医生人员手卫生依从率(%)" />
          <el-table-column prop="fz2_2" label="医疗机构护士人员实际执行手卫生时机数" />
          <el-table-column prop="fm2_2" label="同期护士人员应执行手卫生时机数" />
          <el-table-column prop="sj2_2" label="医疗机构护士人员手卫生依从率(%)" />
          <el-table-column prop="fz2_3" label="医疗机构其他人员实际执行手卫生时机数" />
          <el-table-column prop="fm2_3" label="同期其他人员应执行手卫生时机数" />
          <el-table-column prop="sj2_3" label="医疗机构其他人员手卫生依从率(%)" />
        </el-table-column>
        <el-table-column label="指标三">
          <el-table-column prop="fz3" label="医院感染新发病例例次数" />
          <el-table-column prop="fm3" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj3" label="千日医院感染例次发病率(例/千住院日)(‰)" />
        </el-table-column>
        <el-table-column label="指标四">
          <el-table-column prop="fz4" label="新生儿医院感染新发病例例次数" />
          <el-table-column prop="fm4" label="同期新生儿住院患者累计住院天数" />
          <el-table-column prop="sj4" label="新生儿千日医院感染例次发病率(例/千住院日)(‰)" />
        </el-table-column>
        <el-table-column label="指标五">
          <el-table-column prop="fz5" label="特定多重耐药菌医院感染新发病例例次数" />
          <el-table-column prop="fm5" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5" label="千日特定多重耐药菌医院感染例次发病率(例/千住院日)(‰)" />
          <el-table-column prop="fz5_1" label="耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数" />
          <el-table-column prop="fm5_1" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_1" label="耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)(‰)" />
          <el-table-column prop="fz5_2" label="耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)医院感染新发病例例次数" />
          <el-table-column prop="fm5_2" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_2" label="耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)(例/千住院日)(‰)" />
          <!-- <el-table-column prop="fz5_3" label="耐万古霉素粪肠球菌医院感染新发病例例次数" />
          <el-table-column prop="fm5_3" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_3" label="耐万古霉素粪肠球菌(例/千住院日)(‰)" /> -->
          <el-table-column prop="fz5_4" label="耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数" />
          <el-table-column prop="fm5_4" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_4" label="耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)(‰)" />
          <el-table-column prop="fz5_5" label="耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数" />
          <el-table-column prop="fm5_5" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_5" label="耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)(‰)" />
          <el-table-column prop="fz5_6" label="耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数" />
          <el-table-column prop="fm5_6" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_6" label="耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)(‰)" />
          <el-table-column prop="fz5_7" label="耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数" />
          <el-table-column prop="fm5_7" label="同期住院患者累计住院天数" />
          <el-table-column prop="sj5_7" label="耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)(‰)" />
        </el-table-column>
        <el-table-column label="指标六">
          <el-table-column prop="fz6" label="联合使用重点抗菌药物治疗前病原学送检的住院患者人数" />
          <el-table-column prop="fm6" label="同期联合使用重点抗菌药物治疗的住院患者总人数" />
          <el-table-column prop="sj6" label="住院患者联合使用重点抗菌药物治疗前病原学送检率(%)" />
        </el-table-column>
        <el-table-column label="指标七">
          <el-table-column prop="fz7" label="住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数" />
          <el-table-column prop="fm7" label="同期住院患者Ⅰ类切口手术总例次数" />
          <el-table-column prop="sj7" label="住院患者I类切口手术抗菌药物预防使用率(%)" />
        </el-table-column>
        <el-table-column label="指标八">
          <el-table-column prop="fz8" label="住院患者Ⅰ类切口手术发生手术部位感染的例次数" />
          <el-table-column prop="fm8" label="同期住院患者Ⅰ类切口手术总例次数" />
          <el-table-column prop="sj8" label="住院患者I类切口手术部位感染率(%)" />
          <el-table-column prop="fz8_1" label="同期I类切口手术(脑出血)发生手术部位感染的例次数" />
          <el-table-column prop="fm8_1" label="同期I类切口手术(脑出血)例次数" />
          <el-table-column prop="sj8_1" label="I类切口手术部位(脑出血)感染率(%)" />
          <el-table-column prop="fz8_2" label="同期I类切口手术(髋关节置换)发生手术部位感染的例次数" />
          <el-table-column prop="fm8_2" label="同期I类切口手术(髋关节置换)例次数" />
          <el-table-column prop="sj8_2" label="I类切口手术部位(髋关节置换)感染率(%)" />
          <el-table-column prop="fz8_3" label="同期I类切口手术(膝关节置换)发生手术部位感染的例次数" />
          <el-table-column prop="fm8_3" label="同期I类切口手术(膝关节置换)例次数" />
          <el-table-column prop="sj8_3" label="I类切口手术部位(膝关节置换)感染率(%)" />
        </el-table-column>
        <el-table-column label="指标九">
          <el-table-column prop="fz9" label="相关血流感染新发病例例次数" />
          <el-table-column prop="fm9" label="同期住院患者血管导管累计使用天数" />
          <el-table-column prop="sj9" label="血管导管相关血流感染发病率(例/千导管日)(%)" />
        </el-table-column>
        <el-table-column label="指标十">
          <el-table-column prop="fz10" label="相关肺炎新发病例例次数" />
          <el-table-column prop="fm10" label="同期住院患者有创呼吸机累计使用天数" />
          <el-table-column prop="sj10" label="呼吸机相关肺炎发病率(例/千导管日)(%)" />
        </el-table-column>
        <el-table-column label="指标十一">
          <el-table-column prop="fz11" label="相关尿路感染新发病例例次数" />
          <el-table-column prop="fm11" label="同期住院患者导尿管累计使用天数" />
          <el-table-column prop="sj11" label="导尿管相关尿路感染发病率(例/千导管日)(%)" />
        </el-table-column>
        <el-table-column label="指标十二">
          <el-table-column prop="fz12" label="血液透析患者新发生相关感染的例次数" />
          <el-table-column prop="fm12" label="同期血液透析总人数" />
          <el-table-column prop="sj12" label="血液透折相关感染发生率(%)" />
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { addIndicators, getIndicators, updateIndicators } from "../../api/indicators";
import { getHospital, getAllArea } from "../../api/hospital";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      title: "统计月份：",
      tjny: '',
      tableData: [
        {
          zb: "指标一",
          nr: "感控专职人员床位比",
          fz: "实际开放床位数",
          fzsz: "",
          fm: "同期感控专职人员数",
          fmsz: "",
          sj: "",
          bz: "",
        },
        {
          zb: "指标二",
          nr: "医疗机构工作人员手卫生依从率",
          fz: "医疗机构工作人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.1",
          nr: "医生",
          fz: "医疗机构医生人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期医生人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.2",
          nr: "护士",
          fz: "医疗机构护士人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期护士人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.3",
          nr: "其他人员",
          fz: "医疗机构其他人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期其他人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标三",
          nr: "千日医院感染例次发病率(例/千住院日)",
          fz: "医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标四",
          nr: "新生儿千日医院感染例次发病率(例/千住院日)",
          fz: "新生儿医院感染新发病例例次数",
          fzsz: "",
          fm: "同期新生儿住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标五",
          nr: "千日特定多重耐药菌医院感染例次发病率(例/千住院日)",
          fz: "特定多重耐药菌医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.1",
          nr: "耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)",
          fz: "耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.2",
          nr: "耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)((例/千住院日)",
          fz: "耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        /*{
          zb: "5.3",
          nr: "耐万古霉素粪肠球菌(例/千住院日)",
          fz: "耐万古霉素粪肠球菌医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },*/
        {
          zb: "5.3",
          nr: "耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)",
          fz: "耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.4",
          nr: "耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)",
          fz: "耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.5",
          nr: "耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)",
          fz: "耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.6",
          nr: "耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)",
          fz: "耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标六",
          nr: "住院患者联合使用重点抗菌药物治疗前病原学送检率",
          fz: "联合使用重点抗菌药物治疗前病原学送检的住院患者人数",
          fzsz: "",
          fm: "同期联合使用重点抗菌药物治疗的住院患者总人数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标七",
          nr: "住院患者I类切口手术抗菌药物预防使用率",
          fz: "住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数",
          fzsz: "",
          fm: "同期住院患者Ⅰ类切口手术总例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标八",
          nr: "住院患者I类切口手术部位感染率",
          fz: "住院患者Ⅰ类切口手术发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期住院患者Ⅰ类切口手术总例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.1",
          nr: "I类切口手术部位(脑出血)感染率",
          fz: "同期I类切口手术(脑出血)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(脑出血)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.2",
          nr: "I类切口手术部位(髋关节置换)感染率",
          fz: "同期I类切口手术(髋关节置换)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(髋关节置换)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.3",
          nr: "I类切口手术部位(膝关节置换)感染率",
          fz: "同期I类切口手术(膝关节置换)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(膝关节置换)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标九",
          nr: "血管导管相关血流感染发病率(例/千导管日)",
          fz: "相关血流感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者血管导管累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰,血管导管包括中心静脉导管(CVC)、经外周置入中心静脉导管(PICC)、输液港(PORT)、脐静脉导管",
        },
        {
          zb: "指标十",
          nr: "呼吸机相关肺炎发病率(例/千导管日)",
          fz: "相关肺炎新发病例例次数",
          fzsz: "",
          fm: "同期住院患者有创呼吸机累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标十一",
          nr: "导尿管相关尿路感染发病率(例/千导管日)",
          fz: "相关尿路感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者导尿管累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标十二",
          nr: "血液透折相关感染发生率",
          fz: "血液透析患者新发生相关感染的例次数",
          fzsz: "",
          fm: "同期血液透析总人数",
          fmsz: "",
          sj: "",
          bz: "%,指标中血液透析患者包括门诊和住院患者。本指标中相关感染是指血管导管相关血流感染、乙型病毒性肝炎、丙型病毒性肝炎、艾滋病和梅毒。各类型感染可分别统计",
        },
      ],
      tableData2: [],
      hospitalNumber: "",
      hospitalName: "",
      filled: true,
      hShow: true,
      bShow: true,
      areaData: [],
      searchArea: "",
      loading: false,
      permission: 0,
      searchHospitalNumber: '',
      hospitalData: [],
      tbButton: true,
      istjny: true
    };
  },
  created() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    this.hospitalName = this.loginUser.HospitalName;
    this.hospitalNumber = this.loginUser.HospitalNumber;
    this.permission = this.loginUser.permission;
    this.tjny = [this.getCurrentYearMonth(), this.getCurrentYearMonth()]
    if (this.permission > 0) {
      this.hShow = true;
    } else this.hShow = false;
  },
  mounted() {
    // this.getData();
    this.getAreaData();
    this.getHospital();
  },
  methods: {
    areaChange() {
      this.searchHospitalNumber = ''
      if (this.searchArea != '' || this.searchHospitalNumber != '') {
        this.tbButton = false
      } else {
        this.tbButton = true
        this.hospitalNumber = this.loginUser.HospitalNumber
      }
    },
    hospitalChange() {
      this.searchArea = ''
      if (this.searchArea != '' || this.searchHospitalNumber != '') {
        this.tbButton = false
      } else {
        this.tbButton = true
        this.hospitalNumber = this.loginUser.HospitalNumber
      }
    },
    getHospital() {
      getHospital({ hospitalName: "" }).then((res) => {
        this.hospitalData = []
        for (let i = 0; i < res.data.length; i++) {
          if (this.permission == 1) {
            this.hospitalData = res.data;
          } else if (this.permission == 2) {
            if (res.data[i].Area.split(',')[1] == this.loginUser.Area.split(',')[1]) {
              this.hospitalData.push(res.data[i])
            }
          } else if (this.permission == 3) {
            if (res.data[i].Area.split(',')[2] == this.loginUser.Area.split(',')[2]) {
              this.hospitalData.push(res.data[i])
            }
          }
        }
      });
    },
    getAreaData() {
      this.area = [];
      getAllArea().then((res) => {
        this.areaData = []
        if (this.permission == 1) {
          this.areaData.push({
            id: "all",
            label: "全部",
          });
          for (let i = 0; i < res.data2.length; i++) {
            this.areaData.push({
              id: res.data2[i].id,
              label: res.data2[i].name,
            });
          }
        } else if (this.permission == 2) {
          this.areaData.push({
            id: this.loginUser.Area.split(",")[1],
            label: "全部",
          });
          for (let i = 0; i < res.data3.length; i++) {
            if (res.data3[i].cityid == this.loginUser.Area.split(',')[1]) {
              this.areaData.push({
                id: res.data3[i].id,
                label: res.data3[i].name,
              });
            }
          }
        } else if (this.permission == 3) {
          this.areaData.push({
            id: this.loginUser.Area.split(",")[2],
            label: "全部",
          });
          for (let i = 0; i < res.data3.length; i++) {
            if (res.data3[i].id == this.loginUser.Area.split(',')[2]) {
              this.areaData.push({
                id: res.data3[i].id,
                label: res.data3[i].name,
              });
            }
          }
        }
      });
    },
    jsjg(row, index) {
      if (row.fzsz == '' || row.fmsz == '') {
        this.tableData[index].sj = 0
      } else {
        if (row.zb == '指标一') {
          this.tableData[index].sj = row.fzsz + ':' + row.fmsz
        } else if (row.zb == '指标二' || row.zb == '2.1' || row.zb == '2.2' || row.zb == '2.3' ||
          row.zb == '指标六' || row.zb == '指标七' || row.zb == '指标八' ||
          row.zb == '8.1' || row.zb == '8.2' || row.zb == '8.3' || row.zb == '指标十二'
        ) {
          if (row.fmsz == 0 || row.fmsz == '') {
            this.tableData[index].sj = '0.00'
          } else {
            this.tableData[index].sj = (row.fzsz / row.fmsz * 100).toFixed(2)
          }
        } else {
          if (row.fmsz == 0 || row.fmsz == '') {
            this.tableData[index].sj = '0.000'
          } else {
            this.tableData[index].sj = (row.fzsz / row.fmsz * 1000).toFixed(3)
          }
        }
      }
    },
    submit() {
      if (!this.tjny) {
        this.$message.warning("请选择填报月份")
        return
      }
      addIndicators({
        tjny: this.tjny[0],
        fz1: this.tableData[0].fzsz || "",
        fm1: this.tableData[0].fmsz || "",
        sj1: this.tableData[0].sj || "",
        fz2: this.tableData[1].fzsz || "",
        fm2: this.tableData[1].fmsz || "",
        sj2: this.tableData[1].sj || "",
        fz2_1: this.tableData[2].fzsz || "",
        fm2_1: this.tableData[2].fmsz || "",
        sj2_1: this.tableData[2].sj || "",
        fz2_2: this.tableData[3].fzsz || "",
        fm2_2: this.tableData[3].fmsz || "",
        sj2_2: this.tableData[3].sj || "",
        fz2_3: this.tableData[4].fzsz || "",
        fm2_3: this.tableData[4].fmsz || "",
        sj2_3: this.tableData[4].sj || "",
        fz3: this.tableData[5].fzsz || "",
        fm3: this.tableData[5].fmsz || "",
        sj3: this.tableData[5].sj || "",
        fz4: this.tableData[6].fzsz || "",
        fm4: this.tableData[6].fmsz || "",
        sj4: this.tableData[6].sj || "",
        fz5: this.tableData[7].fzsz || "",
        fm5: this.tableData[7].fmsz || "",
        sj5: this.tableData[7].sj || "",
        fz5_1: this.tableData[8].fzsz || "",
        fm5_1: this.tableData[8].fmsz || "",
        sj5_1: this.tableData[8].sj || "",
        fz5_2: this.tableData[9].fzsz || "",
        fm5_2: this.tableData[9].fmsz || "",
        sj5_2: this.tableData[9].sj || "",
        fz5_3: '',//this.tableData[10].fzsz||"",
        fm5_3: '',//this.tableData[10].fmsz||"",
        sj5_3: '',//this.tableData[10].sj||"",
        fz5_4: this.tableData[10].fzsz || "",
        fm5_4: this.tableData[10].fmsz || "",
        sj5_4: this.tableData[10].sj || "",
        fz5_5: this.tableData[11].fzsz || "",
        fm5_5: this.tableData[11].fmsz || "",
        sj5_5: this.tableData[11].sj || "",
        fz5_6: this.tableData[12].fzsz || "",
        fm5_6: this.tableData[12].fmsz || "",
        sj5_6: this.tableData[12].sj || "",
        fz5_7: this.tableData[13].fzsz || "",
        fm5_7: this.tableData[13].fmsz || "",
        sj5_7: this.tableData[13].sj || "",
        fz6: this.tableData[14].fzsz || "",
        fm6: this.tableData[14].fmsz || "",
        sj6: this.tableData[14].sj || "",
        fz7: this.tableData[15].fzsz || "",
        fm7: this.tableData[15].fmsz || "",
        sj7: this.tableData[15].sj || "",
        fz8: this.tableData[16].fzsz || "",
        fm8: this.tableData[16].fmsz || "",
        sj8: this.tableData[16].sj || "",
        fz8_1: this.tableData[17].fzsz || "",
        fm8_1: this.tableData[17].fmsz || "",
        sj8_1: this.tableData[17].sj || "",
        fz8_2: this.tableData[18].fzsz || "",
        fm8_2: this.tableData[18].fmsz || "",
        sj8_2: this.tableData[18].sj || "",
        fz8_3: this.tableData[19].fzsz || "",
        fm8_3: this.tableData[19].fmsz || "",
        sj8_3: this.tableData[19].sj || "",
        fz9: this.tableData[20].fzsz || "",
        fm9: this.tableData[20].fmsz || "",
        sj9: this.tableData[20].sj || "",
        fz10: this.tableData[21].fzsz || "",
        fm10: this.tableData[21].fmsz || "",
        sj10: this.tableData[21].sj || "",
        fz11: this.tableData[22].fzsz || "",
        fm11: this.tableData[22].fmsz || "",
        sj11: this.tableData[22].sj || "",
        fz12: this.tableData[23].fzsz || "",
        fm12: this.tableData[23].fmsz || "",
        sj12: this.tableData[23].sj || "",
        hNumber: this.hospitalNumber,
        dataType: '手工录入结果',
      }).then((res) => {
        if (res.data > 0) {
          this.$message.success("提交成功");
          this.bShow = true;
          this.getData();
        } else {
          this.$message.warning("提交失败");
        }
      });
    },
    fillOut() {
      if (this.tjny[0] != this.tjny[1]) {
        this.$message.warning("请按月填报数据")
        return
      }
      this.filled = true;
      this.bShow = false;
    },
    getData() {
      if (!this.tjny) {
        this.$message.warning("请选择需要查询的月份")
        return
      }
      this.bShow = true;
      this.loading = true;
      this.filled = false;
      if (this.searchHospitalNumber != '') {
        this.hospitalNumber = this.searchHospitalNumber
        for (let i = 0; i < this.hospitalData.length; i++) {
          if (this.searchHospitalNumber == this.hospitalData[i].HospitalNumber) {
            this.hospitalName = this.hospitalData[i].HospitalName
          }
        }
      }
      if (this.searchArea != '') {
        this.hospitalNumber = this.searchArea
      }
      getIndicators({
        kssj: this.tjny[0],
        jssj: this.tjny[1],
        hNumber: this.hospitalNumber.toString()
      }).then((res) => {
        if (res.data.length > 0) {
          if (this.tjny[0] == this.tjny[1] && this.searchArea == '') {
            this.istjny = true
            this.tableData[0].fzsz = res.data[0].fz1
            this.tableData[0].fmsz = res.data[0].fm1
            this.tableData[0].sj = res.data[0].sj1

            this.tableData[1].fzsz = res.data[0].fz2
            this.tableData[1].fmsz = res.data[0].fm2
            this.tableData[1].sj = res.data[0].sj2

            this.tableData[2].fzsz = res.data[0].fz2_1
            this.tableData[2].fmsz = res.data[0].fm2_1
            this.tableData[2].sj = res.data[0].sj2_1

            this.tableData[3].fzsz = res.data[0].fz2_2
            this.tableData[3].fmsz = res.data[0].fm2_2
            this.tableData[3].sj = res.data[0].sj2_2

            this.tableData[4].fzsz = res.data[0].fz2_3
            this.tableData[4].fmsz = res.data[0].fm2_3
            this.tableData[4].sj = res.data[0].sj2_3

            this.tableData[5].fzsz = res.data[0].fz3
            this.tableData[5].fmsz = res.data[0].fm3
            this.tableData[5].sj = res.data[0].sj3

            this.tableData[6].fzsz = res.data[0].fz4
            this.tableData[6].fmsz = res.data[0].fm4
            this.tableData[6].sj = res.data[0].sj4

            this.tableData[7].fzsz = res.data[0].fz5
            this.tableData[7].fmsz = res.data[0].fm5
            this.tableData[7].sj = res.data[0].sj5

            this.tableData[8].fzsz = res.data[0].fz5_1
            this.tableData[8].fmsz = res.data[0].fm5_1
            this.tableData[8].sj = res.data[0].sj5_1

            this.tableData[9].fzsz = res.data[0].fz5_2
            this.tableData[9].fmsz = res.data[0].fm5_2
            this.tableData[9].sj = res.data[0].sj5_2

            // this.tableData[10].fzsz = res.data[0].fz5_3
            // this.tableData[10].fmsz = res.data[0].fm5_3
            // this.tableData[10].sj = res.data[0].fm5_3

            this.tableData[10].fzsz = res.data[0].fz5_4
            this.tableData[10].fmsz = res.data[0].fm5_4
            this.tableData[10].sj = res.data[0].sj5_4

            this.tableData[11].fzsz = res.data[0].fz5_5
            this.tableData[11].fmsz = res.data[0].fm5_5
            this.tableData[11].sj = res.data[0].sj5_5

            this.tableData[12].fzsz = res.data[0].fz5_6
            this.tableData[12].fmsz = res.data[0].fm5_6
            this.tableData[12].sj = res.data[0].sj5_6

            this.tableData[13].fzsz = res.data[0].fz5_7
            this.tableData[13].fmsz = res.data[0].fm5_7
            this.tableData[13].sj = res.data[0].sj5_7

            this.tableData[14].fzsz = res.data[0].fz6
            this.tableData[14].fmsz = res.data[0].fm6
            this.tableData[14].sj = res.data[0].sj6

            this.tableData[15].fzsz = res.data[0].fz7
            this.tableData[15].fmsz = res.data[0].fm7
            this.tableData[15].sj = res.data[0].sj7

            this.tableData[16].fzsz = res.data[0].fz8
            this.tableData[16].fmsz = res.data[0].fm8
            this.tableData[16].sj = res.data[0].sj8

            this.tableData[17].fzsz = res.data[0].fz8_1
            this.tableData[17].fmsz = res.data[0].fm8_1
            this.tableData[17].sj = res.data[0].sj8_1

            this.tableData[18].fzsz = res.data[0].fz8_2
            this.tableData[18].fmsz = res.data[0].fm8_2
            this.tableData[18].sj = res.data[0].sj8_2

            this.tableData[19].fzsz = res.data[0].fz8_3
            this.tableData[19].fmsz = res.data[0].fm8_3
            this.tableData[19].sj = res.data[0].sj8_3

            this.tableData[20].fzsz = res.data[0].fz9
            this.tableData[20].fmsz = res.data[0].fm9
            this.tableData[20].sj = res.data[0].sj9

            this.tableData[21].fzsz = res.data[0].fz10
            this.tableData[21].fmsz = res.data[0].fm10
            this.tableData[21].sj = res.data[0].sj10

            this.tableData[22].fzsz = res.data[0].fz11
            this.tableData[22].fmsz = res.data[0].fm11
            this.tableData[22].sj = res.data[0].sj11

            this.tableData[23].fzsz = res.data[0].fz12
            this.tableData[23].fmsz = res.data[0].fm12
            this.tableData[23].sj = res.data[0].sj12
          } else {
            this.tableData2 = res.data
            this.istjny = false
          }
        } else {
          if (this.tjny[0] == this.tjny[1]) {
            this.istjny = true
            this.tableData[0].fzsz = ''
            this.tableData[0].fmsz = ''
            this.tableData[0].sj = ''

            this.tableData[1].fzsz = ''
            this.tableData[1].fmsz = ''
            this.tableData[1].sj = ''

            this.tableData[2].fzsz = ''
            this.tableData[2].fmsz = ''
            this.tableData[2].sj = ''

            this.tableData[3].fzsz = ''
            this.tableData[3].fmsz = ''
            this.tableData[3].sj = ''

            this.tableData[4].fzsz = ''
            this.tableData[4].fmsz = ''
            this.tableData[4].sj = ''

            this.tableData[5].fzsz = ''
            this.tableData[5].fmsz = ''
            this.tableData[5].sj = ''

            this.tableData[6].fzsz = ''
            this.tableData[6].fmsz = ''
            this.tableData[6].sj = ''

            this.tableData[7].fzsz = ''
            this.tableData[7].fmsz = ''
            this.tableData[7].sj = ''

            this.tableData[8].fzsz = ''
            this.tableData[8].fmsz = ''
            this.tableData[8].sj = ''

            this.tableData[9].fzsz = ''
            this.tableData[9].fmsz = ''
            this.tableData[9].sj = ''

            // this.tableData[10].fzsz = ''
            // this.tableData[10].fmsz = ''
            // this.tableData[10].sj = ''

            this.tableData[10].fzsz = ''
            this.tableData[10].fmsz = ''
            this.tableData[10].sj = ''

            this.tableData[11].fzsz = ''
            this.tableData[11].fmsz = ''
            this.tableData[11].sj = ''

            this.tableData[12].fzsz = ''
            this.tableData[12].fmsz = ''
            this.tableData[12].sj = ''

            this.tableData[13].fzsz = ''
            this.tableData[13].fmsz = ''
            this.tableData[13].sj = ''

            this.tableData[14].fzsz = ''
            this.tableData[14].fmsz = ''
            this.tableData[14].sj = ''

            this.tableData[15].fzsz = ''
            this.tableData[15].fmsz = ''
            this.tableData[15].sj = ''

            this.tableData[16].fzsz = ''
            this.tableData[16].fmsz = ''
            this.tableData[16].sj = ''

            this.tableData[17].fzsz = ''
            this.tableData[17].fmsz = ''
            this.tableData[17].sj = ''

            this.tableData[18].fzsz = ''
            this.tableData[18].fmsz = ''
            this.tableData[18].sj = ''

            this.tableData[19].fzsz = ''
            this.tableData[19].fmsz = ''
            this.tableData[19].sj = ''

            this.tableData[20].fzsz = ''
            this.tableData[20].fmsz = ''
            this.tableData[20].sj = ''

            this.tableData[21].fzsz = ''
            this.tableData[21].fmsz = ''
            this.tableData[21].sj = ''

            this.tableData[22].fzsz = ''
            this.tableData[22].fmsz = ''
            this.tableData[22].sj = ''

            this.tableData[23].fzsz = ''
            this.tableData[23].fmsz = ''
            this.tableData[23].sj = ''
          } else {
            this.tableData2 = []
            this.istjny = false
          }
          this.$message.info("无数据")
        }
        this.loading = false
      });
    },
    getLastDayOfMonth(year, month) {
      const date = new Date(year, month, 1); // 设置日期为当月第一天
      date.setMonth(date.getMonth()); // 月份加1变为下一个月
      date.setDate(0); // 日期设置为0,自动变为上个月的最后一天
      return date.getDate();
    },
    getCurrentYearMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      return `${year}-${month}`;
    },
    exportData() {
      if (this.tjny[0] == this.tjny[1]) {
        // 1. 准备导出数据
        const exportData = this.tableData.map(item => ({
          '指标': item.zb,
          '内容': item.nr,
          '分子': item.fz,
          '分子数值': item.fzsz,
          '分母': item.fm,
          '分母数值': item.fmsz,
          '结果数据': item.sj,
          '备注': item.bz
        }));

        // 2. 创建工作表
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 3. 插入顶部标题(在 A1 单元格)
        const title = '感控十二项指标-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1];
        XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: 'A1' });

        // 4. 合并 A1:H1(共 8 列)
        ws['!merges'] = ws['!merges'] || [];
        ws['!merges'].push({
          s: { r: 0, c: 0 },  // 开始：第 0 行,第 0 列(A1)
          e: { r: 0, c: 7 }   // 结束：第 0 行,第 7 列(H1)
        });

        // 5. 调整数据从第 3 行开始(跳过标题和空行)
        // 注意：json_to_sheet 默认从第 2 行开始写表头,所以我们需要把表头也往下移
        XLSX.utils.sheet_add_json(ws, exportData, { origin: 'A3' });

        // 6. 删除原来的表头行(第 2 行)避免重复
        if (ws['A2']) delete ws['A2'];
        if (ws['B2']) delete ws['B2'];
        if (ws['C2']) delete ws['C2'];
        if (ws['D2']) delete ws['D2'];
        if (ws['E2']) delete ws['E2'];
        if (ws['F2']) delete ws['F2'];
        if (ws['G2']) delete ws['G2'];
        if (ws['H2']) delete ws['H2'];

        ws['!merges'].push({
          s: { r: 0, c: 0 }, // 开始单元格：A1 (第0行,第0列)
          e: { r: 1, c: 7 }  // 结束单元格：H2 (第1行,第7列)
        });

        // 7. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 7, r: exportData.length + 2 }  // +2：标题行 + 表头行
        });

        // 8. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感控十二项指标');
        XLSX.writeFile(wb, '感控十二项指标-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
      } else {
        // 1. 准备导出数据
        const exportData = this.tableData2.map(item => ({
          '备注': item.dataType,
          '市': item.name,
          '级别': item.HospitalLevel,
          '类型': item.hospitalProperty,
          '医院名称': item.HospitalName,
          '统计月份': item.tjny,
          '实际开放床位数': item.fz1,
          '同期感控专职人员数': item.fm1,
          '感控专职人员床位比': item.sj1,

          '医疗机构工作人员实际执行手卫生时机数': item.fz2,
          '同期应执行手卫生时机数': item.fm2,
          '医疗机构工作人员手卫生依从率': item.sj2,
          '医疗机构医生人员实际执行手卫生时机数': item.fz2_1,
          '同期医生人员应执行手卫生时机数': item.fm2_1,
          '医疗机构医生人员手卫生依从率': item.sj2_1,
          '医疗机构护士人员实际执行手卫生时机数': item.fz2_2,
          '同期护士人员应执行手卫生时机数': item.fm2_2,
          '医疗机构护士人员手卫生依从率': item.sj2_2,
          '医疗机构其他人员实际执行手卫生时机数': item.fz2_3,
          '同期其他人员应执行手卫生时机数': item.fm2_3,
          '医疗机构其他人员手卫生依从率': item.sj2_3,

          '医院感染新发病例例次数': item.fz3,
          '同期住院患者累计住院天数': item.fm3,
          '千日医院感染例次发病率(例/千住院日)': item.sj3,

          '新生儿医院感染新发病例例次数': item.fz4,
          '同期新生儿住院患者累计住院天数': item.fm4,
          '新生儿千日医院感染例次发病率(例/千住院日)': item.sj4,

          '特定多重耐药菌医院感染新发病例例次数': item.fz5,
          '同期住院患者累计住院天数0': item.fm5,
          '千日特定多重耐药菌医院感染例次发病率(例/千住院日)': item.sj5,
          '耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数': item.fz5_1,
          '同期住院患者累计住院天数1': item.fm5_1,
          '耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)': item.sj5_1,
          '耐万古霉素屎肠球菌医院感染新发病例例次数': item.fz5_2,
          '同期住院患者累计住院天数2': item.fm5_2,
          '耐万古霉素屎肠球菌(例/千住院日)': item.sj5_2,
          // '耐万古霉素粪肠球菌医院感染新发病例例次数': item.fz5_3,
          // '同期住院患者累计住院天数3': item.fm5_3,
          // '耐万古霉素粪肠球菌(例/千住院日)': item.sj5_3,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数': item.fz5_4,
          '同期住院患者累计住院天数4': item.fm5_4,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)': item.sj5_4,
          '耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数': item.fz5_5,
          '同期住院患者累计住院天数5': item.fm5_5,
          '耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)': item.sj5_5,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数': item.fz5_6,
          '同期住院患者累计住院天数6': item.fm5_6,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)': item.sj5_6,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数': item.fz5_7,
          '同期住院患者累计住院天数7': item.fm5_7,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)': item.sj5_7,

          '联合使用重点抗菌药物治疗前病原学送检的住院患者人数': item.fz6,
          '同期联合使用重点抗菌药物治疗的住院患者总人数': item.fm6,
          '住院患者联合使用重点抗菌药物治疗前病原学送检率': item.sj6,

          '住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数': item.fz7,
          '同期住院患者Ⅰ类切口手术总例次数': item.fm7,
          '住院患者I类切口手术抗菌药物预防使用率': item.sj7,


          '住院患者Ⅰ类切口手术发生手术部位感染的例次数': item.fz8,
          '同期住院患者Ⅰ类切口手术总例次数0': item.fm8,
          '住院患者I类切口手术部位感染率': item.sj8,
          '同期I类切口手术(脑出血)发生手术部位感染的例次数': item.fz8_1,
          '同期I类切口手术(脑出血)例次数': item.fm8_1,
          'I类切口手术部位(脑出血)感染率': item.sj8_1,
          '同期I类切口手术(髋关节置换)发生手术部位感染的例次数': item.fz8_2,
          '同期I类切口手术(髋关节置换)例次数': item.fm8_2,
          'I类切口手术部位(髋关节置换)感染率': item.sj8_2,
          '同期I类切口手术(膝关节置换)发生手术部位感染的例次数': item.fz8_3,
          '同期I类切口手术(膝关节置换)例次数': item.fm8_3,
          'I类切口手术部位(膝关节置换)感染率': item.sj8_3,

          '相关血流感染新发病例例次数': item.fz9,
          '同期住院患者血管导管累计使用天数': item.fm9,
          '血管导管相关血流感染发病率(例/千导管日)': item.sj9,

          '相关肺炎新发病例例次数': item.fz10,
          '同期住院患者有创呼吸机累计使用天数': item.fm10,
          '呼吸机相关肺炎发病率(例/千导管日)': item.sj10,

          '相关尿路感染新发病例例次数': item.fz11,
          '同期住院患者导尿管累计使用天数': item.fm11,
          '导尿管相关尿路感染发病率(例/千导管日)': item.sj11,

          '血液透析患者新发生相关感染的例次数': item.fz12,
          '同期血液透析总人数': item.fm12,
          '血液透折相关感染发生率': item.sj12,
        }));

        // 2. 创建工作表(不带表头)
        const ws = XLSX.utils.json_to_sheet(exportData, { skipHeader: true });

        // 3. 插入文件名称行
        let fileName = ''
        if (this.searchArea != '') {
          fileName = '感控十二项指标-' + this.tjny[0] + '-' + this.tjny[1];
        } else {
          fileName = '感控十二项指标-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1];
        }
        ws['A1'] = { v: fileName, t: 's' };
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 77 } }];

        // 4. 插入多级标题行
        const merges = [
          { s: { r: 1, c: 6 }, e: { r: 1, c: 8 } }, // 指标一
          { s: { r: 1, c: 9 }, e: { r: 1, c: 20 } }, // 指标二
          { s: { r: 1, c: 21 }, e: { r: 1, c: 23 } }, // 指标三
          { s: { r: 1, c: 24 }, e: { r: 1, c: 26 } }, // 指标四
          { s: { r: 1, c: 27 }, e: { r: 1, c: 47 } }, // 指标五
          { s: { r: 1, c: 48 }, e: { r: 1, c: 50 } }, // 指标六
          { s: { r: 1, c: 51 }, e: { r: 1, c: 53 } }, // 指标七
          { s: { r: 1, c: 54 }, e: { r: 1, c: 65 } }, // 指标八
          { s: { r: 1, c: 66 }, e: { r: 1, c: 68 } }, // 指标九
          { s: { r: 1, c: 69 }, e: { r: 1, c: 71 } }, // 指标十
          { s: { r: 1, c: 72 }, e: { r: 1, c: 74 } }, // 指标十一
          { s: { r: 1, c: 75 }, e: { r: 1, c: 77 } }, // 指标十二
        ];

        const titles = [
          '指标一', '指标二', '指标三', '指标四', '指标五', '指标六', '指标七', '指标八', '指标九', '指标十', '指标十一', '指标十二'
        ];

        merges.forEach((merge, index) => {
          ws['!merges'].push(merge);
          const cellRef = XLSX.utils.encode_cell({ r: 1, c: merge.s.c });
          ws[cellRef] = { v: titles[index], t: 's' };
        });

        // 5. 添加列标题行
        const headers = Object.keys(exportData[0]);
        headers.forEach((header, colIndex) => {
          const cellRef = XLSX.utils.encode_cell({ r: 2, c: colIndex });
          ws[cellRef] = { v: header, t: 's' };
        });

        // 6. 合并A2和A3单元格,并设置值为"统计月份"
        ws['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 2, c: 0 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 0 })] = { v: '备注', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 1 }, e: { r: 2, c: 1 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 1 })] = { v: '市', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 2 }, e: { r: 2, c: 2 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 2 })] = { v: '级别', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 3 }, e: { r: 2, c: 3 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 3 })] = { v: '类型', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 4 }, e: { r: 2, c: 4 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 4 })] = { v: '医院名称', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 5 }, e: { r: 2, c: 5 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 5 })] = { v: '统计月份', t: 's' };

        // 7. 调整数据从第 4 行开始(跳过标题和空行)
        let row = 3; // 从第4行开始写入数据
        exportData.forEach(item => {
          Object.keys(item).forEach((key, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
            ws[cellRef] = { v: item[key], t: typeof item[key] === 'number' ? 'n' : 's' }; // 根据数据类型选择 'n' 或 's'
          });
          row++;
        });

        // 8. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 77, r: row - 1 }  // 文件名称行 + 多级标题行 + 列标题行 + 数据行数
        });

        // 9. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感控十二项指标');
        if (this.searchArea != '') {
          XLSX.writeFile(wb, '感控十二项指标-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
        } else {
          XLSX.writeFile(wb, '感控十二项指标-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
        }
      }
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}

.stsearch {
  text-align: center;
}

.text-c {
  text-align: center;
}

.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/indicators.vue